// Single source of truth for brand identity across the app.
// Change these values here to rebrand the entire application.
export const BRAND = {
  name: "Counseltaria\u2122",
  shortName: "Counseltaria\u2122",
  tagline: "A private space for anyone — book a confidential video session.",
  website: "https://counseltaria.com",
  supportEmail: "help.counseltaria@gmail.com",
  bookingSupportEmail: "book.counseltaria@gmail.com",
  logoText: "Counseltaria\u2122",
  logoUrl: "https://customer-assets-7cd3h4nn.emergentagent.net/job_bcab2c86-cd09-48a7-ac23-851caffb2771/artifacts/dvr0slbl_logo_cta.jpeg",
  copyright: () => `© ${new Date().getFullYear()} Counseltaria\u2122 · Counseling for every age`,
  themeColor: "#5B7553",
};

export default BRAND;
